<template>
  <model-table
    ref="modelTable"
    :collection="boxOfficeReports"
    :columns="columns"
    :show-add="false"
    :show-edit="false"
    sort-by="startDate"
    :descending="true"
    :submodel="submodel"
    :show-model-level="!submodel"
    :initial-selection="initialSelection"
  >
    <template
      #header-buttons
    >
      <q-btn
        v-if="!submodel"
        label="Edit Dates"
        outline
        @click.stop="showDateEditor = true"
      />
      <q-btn
        v-if="!submodel"
        label="Generate"
        outline
        :loading="checking"
        @click.stop="checkForNewBors"
      />
    </template>
    <template
      #prepend-row-actions="props"
    >
      <q-btn
        label="View"
        @click.stop="view(props.row)"
      />
    </template>
    <box-office-report-form />
    <box-office-report-date-editor
      v-model="showDateEditor"
      :movie="movie"
      :movie-term="movieTerm"
    />
  </model-table>
</template>

<script>
import BoxOfficeReport from 'src/models/box-office-report/BoxOfficeReport'
import BoxOfficeReportDateEditor from 'src/modules/admin/box-office-report/BoxOfficeReportDateEditor'
import BoxOfficeReportForm from 'src/modules/admin/box-office-report/BoxOfficeReportForm'
import ModelTable from 'src/modules/admin/components/ModelTable'

export default {
  name: 'BoxOfficeReportTable',
  components: {
    ModelTable,
    BoxOfficeReportForm,
    BoxOfficeReportDateEditor
  },
  models: {
    boxOfficeReports: {
      movie: 'default',
      movieTerm: {
        showingBadges: 'default'
      },
      studio: 'default',
      locked: true,
      variables () {
        return {
          movieId: this.movie?.id,
          movieTermId: this.movieTerm?.id,
          studioSettlementId: this.studioSettlement?.id
        }
      },
      immediate: false
    }
  },
  props: {
    movie: {
      type: Object,
      required: false,
      default: null
    },
    movieTerm: {
      type: Object,
      required: false,
      default: null
    },
    studioSettlement: {
      type: Object,
      required: false,
      default: null
    },
    submodel: {
      type: Boolean,
      required: false,
      default: false
    },
    initialSelection: {
      type: Array,
      required: false,
      default: () => ([])
    },
    columnFn: {
      type: Function,
      required: false,
      default: (columns) => columns
    }
  },
  data () {
    return {
      showDateEditor: false,
      checking: false
    }
  },
  computed: {
    columns () {
      return _.compact(this.columnFn([
        { name: 'id', field: bor => bor.id },
        { field: 'movie', component: 'model', editPath: 'movie-terms' },
        { field: 'movieTerm', component: 'model', editDisabled: true },
        { field: 'studio', component: 'model' },
        { label: 'Send Status', name: 'status', field: bor => this.statusIcon(bor.status), component: 'icon' },
        { name: 'startDate', field: bor => bor.startDate, component: 'full-date' },
        { name: 'endDate', field: bor => bor.endDate, component: 'full-date' },
        { name: 'weekNumber', field: bor => bor.shortWeekName, component: 'chip' },
        { name: 'overlap', field: bor => bor.overlaps ? { name: 'error', color: 'negative', tooltip: 'Dates overlap with other BORs' } : { name: 'info', color: 'positive', tooltip: 'Dates do not overlap with other BORs' }, component: 'icon' },
        { name: 'Term', field: bor => (!bor.hasFlatFee && bor.termPercentHundredths ? ((bor.termPercentHundredths / 100.0) + '%') : '—') },
        { name: 'Flat Fee', field: bor => bor.hasFlatFee ? bor.flatFee : null, component: 'money' },
        { name: 'count', field: bor => bor.netCount },
        { name: 'grossAmount', field: bor => bor.grossAmount, component: 'money' },
        { name: 'amountDue', field: bor => bor.amountDue, component: 'money' },
        { label: 'Invoice Paid', name: 'invoice-paid', field: bor => this.invoicePaidIcon(bor.invoicePaid), component: 'icon' },
        { label: 'Email BOR Sent', name: 'emailBorSentAt', field: bor => bor.emailBorSentAt, component: 'checkmark-or-negative' },
        { label: 'Swift E-BOR Sent', name: 'swiftEborSubmittedAt', field: bor => bor.swiftEborSubmittedAt, component: 'checkmark-or-negative' },
        { name: 'actions', align: 'right' }
      ]))
    }
  },
  methods: {
    view (bor) {
      bor.view()
    },
    statusIcon (status) {
      if (status === 'complete') return { name: 'check_circle', color: 'positive', tooltip: 'Sent' }
      if (status === 'no-reporting') return { name: 'help', color: 'warning', tooltip: 'Reporting is not configured' }
      if (status === 'due-now') return { name: 'event', color: 'warning', tooltip: 'Due now' }
      if (status === 'overdue') return { name: 'cancel', color: 'negative', tooltip: 'Overdue' }
      if (status === 'upcoming') return { name: 'pending', color: 'grey', tooltip: 'Upcoming' }
    },
    invoicePaidIcon (invoicePaid) {
      if (invoicePaid) {
        return {
          name: 'paid',
          color: 'positive',
          tooltip: 'Invoice marked as paid'
        }
      } else {
        return {
          name: 'waiting',
          color: 'grey',
          tooltip: 'Invoice not marked as paid'
        }
      }
    },
    async checkForNewBors () {
      this.checking = true
      await new BoxOfficeReport().checkForNewBors()
      this.checking = false
      this.boxOfficeReports.fetch(true)
    }
  }
}
</script>
